export default {
  created: function () {
    this.hello()
  },
  methods: {
    hello: function () {
    },
    getDistanceFromCoordinates: function (from, to) {
      var R = 6371
      var dLat = this.toDeg(to.lat - from.lat)
      var dLon = this.toDeg(to.lng - from.lng)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toDeg(from.lat)) * Math.cos(this.toDeg(to.lat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)

      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return d
    },
    toDeg: function (deg) {
      return deg * (Math.PI / 180)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Utils.js